/**
 * Converts an all-caps (or any-case) name into Title Case, e.g. "PIOTR BIELAWSKI" -> "Piotr Bielawski".
 * Employee names come from the Enova HR import, which stores them upper-case; Person names (entered
 * via CV Portal signup) are already mixed-case, which is why this wasn't needed until Employee Overview.
 * Uppercases the first letter after the start of string, a space, hyphen, or apostrophe, so hyphenated
 * and apostrophed names (e.g. "O'BRIEN-SMITH") come out correctly ("O'Brien-Smith").
 */
export function toTitleCase(value: string): string {
    return value.toLowerCase().replace(/(^|[\s\-'])\p{L}/gu, (match) => match.toUpperCase());
}
